module.exports = __webpack_public_path__ + "img/6.f03bb5c8.png";